module.exports = "<svg style=\"width: 15px; height: 15px;\" viewBox=\"1 0 15 15\"><path d=\"M7.58578644,11.2426407 L4.75735931,8.41421356 L12.5355339,0.636038969 L15.363961,3.46446609 L7.58578644,11.2426407 Z M1.63603897,14.363961 L3.05025253,10.1213203 L5.87867966,12.9497475 L1.63603897,14.363961 Z\" id=\"path-1\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/edit.svg
// module id = 262
// module chunks = 0